import type { BlokProps } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import { Container } from "@/components/ui/Container";
import { RichTextRenderer } from "@/components/ui/RichText";
import type { BlokRichText } from "@/storyblok";
import styles from "./RichTextBlok.module.css";

export const RichTextBlok = ({ blok, preview }: BlokProps<BlokRichText>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<Container>
				{blok.text && (
					<RichTextRenderer
						className={styles.root}
						blok={blok.text}
						preview={preview}
					/>
				)}
			</Container>
		</BlokWrap>
	);
};
